import React, { FC } from 'react';
import Form from 'components/Form';

import { GavisconPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Gaviscon: FC<GavisconPageProps> = ({ pageContext, location }) => (
  <Form {...{
    ...{ ...pageContext, location, translations: { ...pageContext.translations, pageTitle: '' } },
  }} />
);

export default Gaviscon;
